


























import mixins from 'vue-typed-mixins';
import UserUtils, { User } from '../../utils/UserUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => User,
    },
  },
  methods: {
    async submit() {
      try {
        if (this.value) {
          this.$alert.hide('submit');
          await UserUtils.api.update(this.value);
          this.$emit('pristine', this.value);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.$languageobj('page.profile.details.navigation')],
            }),
          });
        }
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
